module.exports = __webpack_public_path__ + "img/7.8ed3a365.jpg";